import { ColorKey } from 'components/ColorKey'
import { CSSProperties, ReactNode } from 'react'
import styled from 'styled-components'

export const ChartFrame = ({
  title,
  lead,
  source,
  footnote,
  children,
  timestamp,
  colorKeyEntries,
  colorKeyIsRange,
  colorMode = 'light',
  lang,
  style
}: {
  title?: string
  lead?: string | ReactNode
  footnote?: string | ReactNode
  source?: string
  children?: ReactNode
  timestamp?: ReactNode
  colorKeyEntries?: { label: string; color: string }[]
  colorKeyIsRange?: boolean
  colorMode?: 'dark' | 'light' | undefined
  lang: 'de' | 'fr'
  style?: CSSProperties
}) => {
  return (
    <ChartFrameRoot className='CHARTFRAME' style={style}>
      {title && <Title>{title}</Title>}
      {lead && (
        <Lead
          colorMode={colorMode}
          style={{
            marginBottom: !colorKeyEntries ? '30px' : undefined,
          }}
        >
          {lead}
        </Lead>
      )}{' '}
      <Spacer />
      {colorKeyEntries && (
        <ColorKey entries={colorKeyEntries} fromto={colorKeyIsRange} />
      )}
      {children}
      {footnote && <Footnote>{footnote}</Footnote>}
      {source && <Source>{source}</Source>}
    </ChartFrameRoot>
  )
}

const ChartFrameRoot = styled.div`
  width: 100%;
  /* height: 100%; */
  margin-top: 60px;
  margin-bottom: 45px;
  /* padding-bottom: 60px; */
  max-width: calc(100vw - 40px);
`

const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  padding-top: 10px;
  font-family: var(--font-serif);
  margin-bottom:15px;
  width: 90%;
  max-width: 80%;
  @media screen and (max-width: 711px) {
    max-width: 100%;
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 15px;
  }
  /* text-align: center; */
`
const Lead = styled.div<{ colorMode?: 'dark' | 'light' | undefined }>`
  font-size: 14px;
  margin-top: 5px;
  line-height: 1.6em;
  /* max-width: 600px; */
  color: var(--chart-lead-color);
  font-size: 18px;
  line-height: 30px;
  font-family: var(--font-serif);
  @media screen and (max-width: 711px) {
    max-width: 100%;
    font-size: 17px;
    line-height: 28px;
  }
`
const Source = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: var(--gray-3);
  line-height: 1.3em;
`
const Footnote = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: var(--gray-3);
  line-height: 1.3em;
`
const Spacer = styled.div`
  height: 30px;
  @media screen and (max-width: 711px) {
    height: 15px;
  }
`
